// extracted by mini-css-extract-plugin
export default {"inner":"SpyMenu_inner__quiDZ","link":"SpyMenu_link__nqvcy","active":"SpyMenu_active__rZ-ud","wrap":"SpyMenu_wrap__-+fyh"};